// Import dependencies
import ReactDOM from 'react-dom';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
// import { offsetLimitPagination } from '@apollo/client/utilities';

// Utils
import { createApolloClient } from '../utils';

// Components
import Search from './components/Search';

const renderSearchListing = () => {
  // todo: pagination
  const fieldPolicies = {
    // Query: { fields: { entries: offsetLimitPagination() } },
  };

  ReactDOM.render(
    <ApolloProvider client={createApolloClient(fieldPolicies)}>
      <Search />
    </ApolloProvider>,
    document.getElementById('search-listing'),
  );
};

export default renderSearchListing;
